import { useEffect, useState } from "react";
import { collection, getDocs, query, where, orderBy } from "firebase/firestore";
import { db } from "../../../firebase/firebaseConfig";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import routePaths from "../../../routes/routePaths";

export default function HomeAboutPreview() {
  const { i18n, t } = useTranslation();
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchItems = async () => {
      const q = query(
        collection(db, "about_highlights"),
        where("active", "==", true),
        orderBy("order", "asc")
      );
      const snapshot = await getDocs(q);
      const data = snapshot.docs.map(doc => {
        const d = doc.data();
        return {
          icon: d.icon,
          text: d.text?.[i18n.language] || d.text?.vi || ""
        };
      });
      setItems(data);
    };

    fetchItems();
  }, [i18n.language]);

  return (
    <section className="py-14 px-4 max-w-5xl mx-auto text-center">
      <h2 className="text-2xl md:text-3xl font-extrabold mb-8 text-primary">
        {t("home.whyChooseUs")}
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-base">
        {items.map((item, idx) => (
          <div
            key={idx}
            className="flex flex-col items-center bg-card rounded border border-border hover:shadow transition group p-5"
          >
            <div className="text-6xl mb-2 text-primary group-hover:scale-110 transition">
              {item.icon}
            </div>
            <p className="mt-1 text-menu">{item.text}</p>
          </div>
        ))}
      </div>
      <div className="mt-8">
        <button
          className="
            bg-card border border-primary 
            text-primary 
            font-semibold 
            px-5 py-2 
            rounded 
            hover:bg-primary hover:text-white 
            transition
          "
          onClick={() => navigate(routePaths.about)}
        >
          {t("home.aboutBtn")}
        </button>
      </div>
    </section>
  );
}
